function DateInputValidator(elemSelector) {
    var elem = document.querySelector(elemSelector)

    if (elem == null) {
        return;
    }

    var requiredMsg = (elem.dataset && elem.dataset.valDate) ? elem.dataset.valDate : 'The field must be a date.';
    var isRequired = (elem.dataset && elem.dataset.valDate);

    function showError(errorMsg) {
        var div = elem.parentElement.parentElement.parentElement;
        var label = div.querySelector('label');

        elem.classList.add('error');

        label
            && $(label).remove();

        $(div).append('<label class="error">' + errorMsg + '</label>');
    }

    function clearError() {
        var div = elem.parentElement.parentElement.parentElement;
        var span = elem.parentElement.querySelector('span');

        elem.classList.remove('error');

        $(div).find('label').remove();
    }

    function isRequiredValid() {
        return (elem.value !== '');
    }

    if (isRequired) {
        $(elem).data("kendoDatePicker") &&
            $(elem).data("kendoDatePicker").bind("change", function() {
                if ($(elem).data("kendoDatePicker").value() !== '') {
                    clearError();
                }
            });
    }

    var m = {
        isValid: function() {
            var isValid = true;

            if (isRequired && !isRequiredValid()) {
                showError(requiredMsg);
                return false;
            }

            return isValid;
        }
    };

    return m;
};

